module.exports = __webpack_public_path__ + "img/home_top.429f11df.jpg";